import { render, staticRenderFns } from "./SingleSignOnTableRow.vue?vue&type=template&id=564bd37a"
import script from "./SingleSignOnTableRow.vue?vue&type=script&lang=js"
export * from "./SingleSignOnTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports